export default __webpack_public_path__ + "8a0c104e0a42bd5fd1092e681412e963.png";